module.exports = __webpack_public_path__ + "img/account-card.4d0ba530.svg";